import Page403 from './403-page';

export default Page403;